import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress the (dev-only) react-error-overlay for benign cross-origin
// "Script error." events thrown by third-party embeds (e.g. TradingView widget).
if (process.env.NODE_ENV === "development") {
  const isScriptError = (t) => typeof t === "string" && t.includes("Script error");
  window.addEventListener(
    "error",
    (e) => {
      if (e && isScriptError(e.message)) e.stopImmediatePropagation();
    },
    true,
  );
  // Remove the CRA dev overlay iframe only when it reports the benign "Script error."
  const observer = new MutationObserver(() => {
    const overlay = document.getElementById("webpack-dev-server-client-overlay");
    if (!overlay) return;
    try {
      const doc = overlay.contentDocument;
      if (doc && isScriptError(doc.body.innerText)) overlay.remove();
    } catch (_) {
      /* ignore */
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
